import { render, staticRenderFns } from "./AppClip.vue?vue&type=template&id=0cf19aa4&scoped=true"
import script from "./AppClip.vue?vue&type=script&lang=js"
export * from "./AppClip.vue?vue&type=script&lang=js"
import style0 from "./AppClip.vue?vue&type=style&index=0&id=0cf19aa4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf19aa4",
  null
  
)

export default component.exports